import { lazy } from 'react';

export const ConfirmEmailVault = lazy(() => import('./ConfirmEmailVault.component'));
